import React from "react";
import { ClientJobSchedule } from "../../..";

const JobSpecificUsersReport = () => {
  return (
    <div>
      <ClientJobSchedule type="JobSpecificUsersReport" />
    </div>
  );
};

export default JobSpecificUsersReport;
